import { atom } from 'recoil';

export const isTrucksFilterModalOpenAtom = atom<boolean>({
  key: 'isTrucksFilterModalOpenState',
  default: false,
});
